import * as Yup from 'yup'

export const orientacoesSchema = Yup.object().shape({
  orientacoes: Yup.string().trim().required('É necessário preencher as orientações'),
  titulo: Yup.string().trim().required('É necessário preencher o título'),
})
